import { render, staticRenderFns } from "./UserPromoCodeBanners.vue?vue&type=template&id=33f4eae2&"
import script from "./UserPromoCodeBanners.vue?vue&type=script&lang=js&"
export * from "./UserPromoCodeBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports